import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga';

export default function UpdatePage({title}) {
    let location = useLocation();

    useEffect(() => {
        document.title = title
        ReactGA.pageview(`${location.pathname}${location.hash}`)
    }, [location, title])

    return null;
}